module.exports = __webpack_public_path__ + "img/about.376e1014.jpg";